import '../../styles/default.css';
import '../../styles/content-builder.css';
import {
  TopInfoBanner,
  Loader,
  ZemplinLoaderWrapper,
  BreadCrumb,
  prop,
} from '@bart.sk-eshop/eshop-defaults';
import * as React from 'react';
import styled from 'styled-components';
import * as cookie from 'react-cookies';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import {
  loadFooterData,
  setCurrency,
  loadDefaultSettings,
  setLanguage,
  loadTopMenuBrands,
  loadSitemapSubtreeByUid,
  resetToken,
  setHostname,
  loadOtherText,
} from './actions';
import {
  dimmerVisibilitySelector,
  currentThemeSelector,
  otherTextSelector,
} from './selectors';
import Dimmer from '../../components/_helpers/Dimmer/Dimmer';
import { loadCategoriesTree } from '../Header/actions';
import Footer from '../Footer/Footer';
import { GlobalStyles } from '../../theme/globalStyles';
import {
  OrganizationMicrodata,
  WebSiteMicrodata,
} from '../../components/_helpers/Microdata/Microdata';
import { checksRedirect } from '@bart.sk-eshop/react-eshop-redirects/lib/action';
import { theme } from '../../theme/theme';
import ContainerHeader from '../Header/Header';
import { rem } from 'polished';
import { USER_COOKIE } from '@bart.sk-eshop/react-auth';
import { loginUser } from '@bart.sk-eshop/react-auth/lib/containers/Auth/actions';
import { ThemeProvider } from '../../theme/styled-components';
import { loadHomeSaleProducts, loadHomeNewProducts } from '../Home/actions';
import { fetchCart } from '../Cart/cartSlice';
import AddedToCartModal from '../Cart/AddedToCartModal';
import BreadCrumbContainer from '../BreadCrumb/BreadCrumb';
import MetaTags from '../../components/_helpers/MetaTags/MetaTags';
import {
  resolveBaseUrlByLang,
  resolveCurrencyByHostname,
  resolveLangByHostname,
} from '../../configureTrans';
import {
  resolveHtmlLangByLang,
  resolveOrganizationInfoByLang,
} from '../../utilities/brand';
import {
  buildHreflangAlternates,
  getLangAbsoluteUrl,
  NOINDEX_FOLLOW,
  shouldNoIndexByPathname,
} from '../../utilities/metatags';
import { __r } from '@bart.sk-eshop/react-i18n';
import CartErrorModal from '../Cart/CartErrorModal';
import CountryPopup from '../../components/_helpers/CountryPopup/CountryPopup';
import TopPromoBar from '../../components/_helpers/TopPromoBar/TopPromoBar';
import {
  detectCountryFromBrowser,
  shouldShowCountryPopup,
  resolveWebsiteByCountry,
  resolvePopupLanguage,
} from '../../services/GeoIPService';
import { getCountryPopupTranslations } from '../../utilities/countryPopupTranslations';
import { CART_COOKIE_ID } from '../Cart/helpers';
import API from '../../services/API';

interface Props {
  user: any;
  lang: string;
  props: any;
  socialUrls: {
    fbUrl: string;
    igUrl: string;
    ytUrl: string;
  };
  metaTags: {
    description: string;
    keywords: string;
    og_article_author: string;
  };
  dispatch: any;
  menuItems: Array<{
    active: boolean;
    name: string;
    url: string;
    attribs: any;
  }>;
  isError: boolean;
  dimmerVisible: boolean;
  currentTheme: string;
  isLoaded: boolean;
  token: string;
  hostname?: string;
  otherText: any;
  location?: any;
  urlTranslations?: any;
}

interface State {
  showCountryPopup: boolean;
  detectedCountry: string | null;
  canLoadChatwoot: boolean;
}

export const FillSpaceWrapper = styled.div`
  display: flex;
  flex-flow: column;
  flex: 1 1 auto;
  min-height: ${rem(600)};

  ${() => theme.mediab.l925`
     min-height: ${rem(400)};
  `}
`;

const COUNTRY_POPUP_DISMISSED_COOKIE = 'country_popup_dismissed';

class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showCountryPopup: false,
      detectedCountry: null,
      canLoadChatwoot: false,
    };
  }

  public static async getInitialProps(props) {
    const { dispatch, token, user, cookies } = props;

    try {
      await dispatch(checksRedirect(props.location));
      await Promise.all([
        dispatch(setLanguage(resolveLangByHostname(props.hostname))),
        dispatch(setCurrency(resolveCurrencyByHostname(props.hostname))),
        dispatch(setHostname(props.hostname)),
        dispatch(loginUser(cookie.load(USER_COOKIE))),
      ]);
      if (process.env.NODE_ENV === 'development') {
        // await dispatch(
        //   loginUser(
        //     '32bd2db5dae5e1028a38e35d18b53c76c039421631d7231ce19318dd0da4787c32e29fa931c202a94db7218cf1f1a10ca4033f4d48f3ed67bac53b7cbd9a369cba2ae86f07f3efa2369453956f2abb26974ca229df776c6fa3b73ba90b983cdf3c45f863d7f30d51214b34aa04f06b3e1c7e23d98ea10468bb3cb83e73ef7157',
        //   ),
        // );
      }

      const cookiesAvailable = cookie.loadAll();
      const userCookie =
        typeof cookies === 'undefined'
          ? cookie.load(USER_COOKIE)
          : prop(cookies, `${USER_COOKIE}`);
      if (userCookie) {
        API.setToken(userCookie);
      } else {
        API.setToken('');
      }

      if (!token || !user) {
        if (userCookie) {
          await dispatch(loginUser(cookie.load(USER_COOKIE)));
        } else if (
          prop(cookiesAvailable, 'cart_id') ||
          prop(cookiesAvailable, 'cc_cookie')
        ) {
          await dispatch(resetToken());
        }
      }
      const cartCookie = prop(cookies, `${CART_COOKIE_ID}`);
      await Promise.all([
        dispatch(loadDefaultSettings()),
        dispatch(loadCategoriesTree()),
        dispatch(loadTopMenuBrands()),
        dispatch(loadFooterData()),
        dispatch(loadSitemapSubtreeByUid('BENEFITS')),
        dispatch(loadOtherText('OZNAM_HORNA_LISTA')),
        dispatch(fetchCart(true, cartCookie)),
      ]);

      return {
        props,
        isLoaded: true,
      };
    } catch (exp) {
      console.log(exp);
      return {
        isError: true,
        isLoaded: true,
      };
    }
  }

  async componentDidMount() {
    // Chatwoot is not localized yet, load it only on SK
    if (this.props.lang === 'sk') {
      this.loadChatwoot();
    }

    // Check if popup was already dismissed
    const dismissed = cookie.load(COUNTRY_POPUP_DISMISSED_COOKIE);

    if (dismissed) {
      return;
    }

    // Detect user's country
    const result = await detectCountryFromBrowser();
    if (!result.detected) {
      return;
    }

    // Check if we should show the popup
    const hostname = this.props.hostname || window.location.hostname;
    const shouldShow = shouldShowCountryPopup(result.country, hostname, false);

    if (shouldShow) {
      this.setState({
        showCountryPopup: true,
        detectedCountry: result.country,
      });
    }
  }

  loadChatwoot = () => {
    this.setState({ canLoadChatwoot: true });
    (window as any).chatwootSettings = {
      position: 'right',
      type: 'expanded_bubble',
      launcherTitle: 'Potrebujete poradiť?',
    };
    const BASE_URL = 'https://app.chatwoot.com';
    const script = document.createElement('script');
    script.async = true;
    script.src = BASE_URL + '/packs/js/sdk.js';
    script.onload = () => {
      (window as any).chatwootSDK.run({
        websiteToken: 'TDmDwNozi95zFijKc7NPT8jy',
        baseUrl: BASE_URL,
      });
    };
    const s = document.getElementsByTagName('script')[0];
    s.parentNode!.insertBefore(script, s);
  };

  handleStayOnCurrentSite = () => {
    // Set cookie to not show popup again for 30 days
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 30);
    cookie.save(COUNTRY_POPUP_DISMISSED_COOKIE, 'true', {
      path: '/',
      expires: expirationDate,
    });
    this.setState({ showCountryPopup: false });
  };

  handleSwitchToOtherSite = () => {
    const { detectedCountry } = this.state;
    if (detectedCountry) {
      const targetUrl = resolveWebsiteByCountry(detectedCountry);
      window.location.href = targetUrl;
    }
  };

  handleClosePopup = () => {
    this.setState({ showCountryPopup: false });
  };

  public render() {
    const {
      children,
      dimmerVisible,
      socialUrls,
      user,
      currentTheme,
      isLoaded,
      token,
      dispatch,
      lang,
      hostname,
      otherText,
      urlTranslations,
    } = this.props;

    const { showCountryPopup, detectedCountry } = this.state;

    const currentThemeColors =
      !currentTheme || !theme[currentTheme]
        ? {
            primary: theme.colors.primary,
            navSecondary: theme.colors.navSecondary,
            paginationSecondary: theme.colors.paginationSecondary,
          }
        : {
            primary: theme[currentTheme].primary,
            navSecondary: theme[currentTheme].navSecondary,
            paginationSecondary: theme[currentTheme].paginationSecondary,
          };

    const notifText =
      otherText && otherText['OZNAM_HORNA_LISTA']
        ? otherText['OZNAM_HORNA_LISTA']
        : null;

    const pathname = prop(this.props, 'location.pathname', '');
    const noIndex = shouldNoIndexByPathname(pathname);
    const alternateUrls = noIndex
      ? []
      : buildHreflangAlternates(pathname, urlTranslations, lang);
    const organizationInfo = resolveOrganizationInfoByLang(lang);
    const isHomepage = !pathname || pathname === '/';

    return (
      <React.Fragment>
        <GlobalStyles />

        {isHomepage && (
          <WebSiteMicrodata
            name={organizationInfo.name}
            url={resolveBaseUrlByLang(lang)}
            inLanguage={resolveHtmlLangByLang(lang)}
            searchUrlTemplate={`${getLangAbsoluteUrl(
              __r('routes:vyhladavanie', '/vyhladavanie'),
              lang,
            )}?q={search_term_string}`}
          />
        )}

        <OrganizationMicrodata
          name={organizationInfo.name}
          url={resolveBaseUrlByLang(lang)}
          logo={`${resolveBaseUrlByLang(
            lang,
          )}/images/golfcentrum/logo-extended.svg`}
          contactPoint={{
            telephone: organizationInfo.telephone,
            email: organizationInfo.email,
            availableLanguage: resolveHtmlLangByLang(lang),
          }}
        />

        <Helmet>
          <html lang={resolveHtmlLangByLang(lang)} />
          {noIndex ? <meta name="robots" content={NOINDEX_FOLLOW} /> : null}
          {alternateUrls.map(alternate =>
            React.createElement('link', {
              key: alternate.hreflang,
              rel: 'alternate',
              hreflang: alternate.hreflang,
              href: alternate.href,
            }),
          )}
          <script
            async
            src={`https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_PUBLIC_RECAPTCHA_SITE_KEY}`}
          ></script>
          {/* {lang === 'cz' ? (
            <meta
              name="google-site-verification"
              content="y83SWeYMq1OmOb63VLeeiUqIH_OWr7VFG2Wax7iUWBQ"
            />
          ) : (
            <meta
              name="google-site-verification"
              content="eyV-2WY8er5DWhrzSuBxXNvnSU3KTEiOwMbiHm8URYk"
            />
          )} */}
        </Helmet>

        <ThemeProvider
          theme={{
            ...theme,
            colors: {
              ...theme.colors,
              ...currentThemeColors,
            },
          }}
        >
          {this.props.metaTags && (
            <MetaTags
              tags={{
                ...this.props.metaTags,
                title: '',
                description: '',
                keywords: '',
                themeColor: currentThemeColors.primary,
              }}
            />
          )}

          {false && user && token && (
            <TopInfoBanner
              message={
                'Objednávky odoslané do 13:00 odošleme ešte dnes. Zľava 2% pri nákupe cez e-shop.'
              }
            />
          )}
          {!!prop(notifText, 'content') && (
            <TopPromoBar
              text={prop(notifText, 'content.json_content.body')}
              link={prop(notifText, 'content.json_content.redir') || ''}
            />
          )}
          <ContainerHeader />
          <BreadCrumbContainer />
          <FillSpaceWrapper>
            {!isLoaded ? <ZemplinLoaderWrapper height={300} /> : children}
          </FillSpaceWrapper>
          <Footer socialUrls={socialUrls} />
          {dimmerVisible && <Dimmer height={null} />}
          <AddedToCartModal dispatch={dispatch} />
          <CartErrorModal dispatch={dispatch} />
          {showCountryPopup && detectedCountry && (
            <CountryPopup
              detectedCountry={detectedCountry}
              {...getCountryPopupTranslations(
                resolvePopupLanguage(
                  detectedCountry,
                  this.props.hostname || prop(window, 'location.hostname', ''),
                ),
                detectedCountry,
                this.props.hostname || prop(window, 'location.hostname', ''),
              )}
              onStay={this.handleStayOnCurrentSite}
              onSwitch={this.handleSwitchToOtherSite}
              onClose={this.handleClosePopup}
            />
          )}
        </ThemeProvider>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    token: state.auth.token,
    socialUrls: state.general.socialUrls,
    metaTags: state.general.metaTags,
    lang: state.general.lang,
    dimmerVisible: dimmerVisibilitySelector(state),
    currentTheme: currentThemeSelector(state),
    otherText: otherTextSelector(state),
    urlTranslations: state.general.urlTranslations,
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'App' })(App),
);
